import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { ChakraProvider } from '@chakra-ui/react'
import { GoogleOAuthProvider } from "@react-oauth/google";
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import Theme from './Theme';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './store/store';

import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ChakraProvider theme={Theme}>
        <GoogleOAuthProvider
          clientId={
            import.meta.env.VITE_GOOGLE_CLIENTID ||
            "apps.googleusercontent.com"
          }
        >
          <HelmetProvider>
            <App />
          </HelmetProvider> 
        </GoogleOAuthProvider>
      </ChakraProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
